<meta name="viewport" content="width=device-width, initial-scale=1.0">
<svg width="100%" height="100%">
  <g *ngFor="let bar of bars">
  <rect [attr.x]="bar.barX" [attr.width]="bar.barWidth" [attr.y]="bar.barY" [attr.height]="bar.barHeigth" [style.fill]="bar.colorFill"
    style="stroke-width:0;stroke:#ffffff;opacity:1"></rect>
    </g>
</svg>
